import React from "react";
import "./AirlineOffers.css";

const AirlineOffers = () => {
  const airlineOffers = [
    {
      id: 1,
      airline: "IndiGo",
      logo: "https://www.gstatic.com/flights/airline_logos/70px/6E.png",
      offer: "UP TO 25% OFF",
      description: "On domestic flight bookings",
      routes: "Delhi • Mumbai • Bangalore • Chennai • Hyderabad",
      rating: "4.2/5",
      popular: true,
    },
    {
      id: 2,
      airline: "Air India",
      logo: "https://www.gstatic.com/flights/airline_logos/70px/AI.png",
      offer: "FLAT 20% OFF",
      description: "International flight offers",
      routes: "USA • UK • Europe • Australia • Middle East",
      rating: "4.0/5",
      popular: false,
    },
    {
      id: 3,
      airline: "Vistara",
      logo: "https://www.gstatic.com/flights/airline_logos/70px/UK.png",
      offer: "BUY 1 GET 1 FREE",
      description: "Premium class special offer",
      routes: "All domestic network routes",
      rating: "4.5/5",
      popular: true,
    },
    {
      id: 4,
      airline: "SpiceJet",
      logo: "https://www.gstatic.com/flights/airline_logos/70px/SG.png",
      offer: "STARTING AT ₹1,499",
      description: "Budget friendly fares",
      routes: "Metro cities & popular destinations",
      rating: "4.1/5",
      popular: false,
    },
    {
      id: 5,
      airline: "AirAsia",
      logo: "https://www.gstatic.com/flights/airline_logos/70px/AK.png",
      offer: "UP TO 30% OFF",
      description: "Southeast Asia destinations",
      routes: "Bangkok • Singapore • Kuala Lumpur • Bali",
      rating: "4.3/5",
      popular: true,
    },
    {
      id: 6,
      airline: "Emirates",
      logo: "https://www.gstatic.com/flights/airline_logos/70px/EK.png",
      offer: "LUXURY DEALS",
      description: "Premium travel experience",
      routes: "Dubai • Europe • USA • Asia • Africa",
      rating: "4.7/5",
      popular: true,
    },
    {
      id: 7,
      airline: "Qatar Airways",
      logo: "https://www.gstatic.com/flights/airline_logos/70px/QR.png",
      offer: "BUSINESS CLASS 15% OFF",
      description: "World's best airline",
      routes: "Global destinations worldwide",
      rating: "4.8/5",
      popular: true,
    },
    {
      id: 8,
      airline: "Singapore Airlines",
      logo: "https://www.gstatic.com/flights/airline_logos/70px/SQ.png",
      offer: "PREMIUM ECONOMY UPGRADE",
      description: "Award winning service",
      routes: "Singapore • Australia • Europe • USA",
      rating: "4.6/5",
      popular: false,
    },
  ];

  return (
    <div className="AirlineOffers">
      <div className="AirlineOffers-section-header">
        <h2>✈️ Exclusive Airline Deals</h2>
        <p>Special offers from top airlines with best ratings</p>
      </div>

      <div className="AirlineOffers-scroll-container">
        <div className="AirlineOffers-scroll">
          {airlineOffers.concat(airlineOffers).map((offer, index) => (
            <div key={`${offer.id}-${index}`} className="AirlineOffers-card">
              {offer.popular && (
                <div className="AirlineOffers-popular-badge">Most Popular</div>
              )}

              <div className="AirlineOffers-card-header">
                <img
                  src={offer.logo}
                  alt={offer.airline}
                  className="AirlineOffers-logo"
                />
                <div className="AirlineOffers-airline-info">
                  <h3>{offer.airline}</h3>
                  <div className="AirlineOffers-rating">
                    <span className="AirlineOffers-stars">★★★★★</span>
                    <span className="AirlineOffers-rating-text">
                      {offer.rating}
                    </span>
                  </div>
                </div>
              </div>

              <div className="AirlineOffers-card-body">
                <div className="AirlineOffers-offer-main">
                  <h4>{offer.offer}</h4>
                  <p>{offer.description}</p>
                </div>

                <div className="AirlineOffers-routes">
                  <span className="AirlineOffers-route-icon">📍</span>
                  <span className="AirlineOffers-route-text">
                    {offer.routes}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AirlineOffers;
